import type { RecoilState } from 'recoil';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
import { localStoragePersisterEffect } from '../utils/recoilEffects';
import { Permissions } from '@sironamedical/common/components/PermissionsCheck/types';

export const permissionsState: RecoilState<Permissions> = atom<Permissions>({
  key: 'userPermissions',
  default: {},
  effects: [localStoragePersisterEffect()],
});

/** Returns the user's permissions */
export const useGetUserPermissions = (): Permissions => useRecoilValue(permissionsState);

/** Saves the user's permissions to Recoil
 * This allows retrieving the user's permissions from any component in the app without using Apollo
 */
export const useSetUserPermissions = (): ((permissions: Permissions) => void) => {
  const setPermissions = useSetRecoilState(permissionsState);
  return (permissions: Permissions) =>
    permissions != null ? setPermissions(permissions) : undefined;
};
